<template>
  <q-item
    v-bind="{ clickable, disable, dense, active, activeClass, tag, dark, insetLevel, tabindex, manualFocus, focused }"
    class="module-item"
    @click="$emit('click')"
  >
    <q-item-section side>
      <date :date="quotation.quotation_date" />
    </q-item-section>
    <q-item-section>
      <q-item-label>
        <span class="module-name">{{ truncateString(quotation.quotation_number, 20) }}</span>
      </q-item-label>
      <q-item-label
        v-if="quotation.address"
        caption
      >
        {{ quotation.address.full_address }}
      </q-item-label>
      <q-item-label
        v-if="quotation.expired_days > 0"
        caption
        class="text-red text-bold"
      >
        {{ expiredDaysStr(quotation) }}
      </q-item-label>
      <Status
        flat
        :quotation="quotation"
        class="q-mt-sm lt-sm"
      />
    </q-item-section>
    <q-item-section
      v-if="validClientSlot && quotation.client"
      class="text-right q-pr-md gt-xs"
      style="max-width: 225px;"
      :title="quotation.client.display_name"
    >
      <q-item-label caption>
        Client
      </q-item-label>
      <div class="text-grey-7 module-name">
        {{ truncateString(quotation.client.display_name) }}
      </div>
    </q-item-section>
    <q-separator
      v-if="validClientSlot"
      vertical
      class="gt-xs"
    />
    <q-item-section
      side
      style="min-width: 90px;"
      class="text-right"
    >
      <q-item-label class="text-bold">
        {{ friendlyNumber(quotation.total, true) }}
      </q-item-label>
    </q-item-section>
    <q-item-section
      side
      style="min-width: 85px;"
      class="q-pl-sm gt-xs"
    >
      <Status :quotation="quotation" />
    </q-item-section>
  </q-item>
</template>

<script>
/*
  Partial to display quotation information on any page
*/
import Status from './Status'
import quotationMixin from 'components/app/quotations/partials/mixin'
import itemMixin from 'src/helpers/item'

export default {
  components: {
    Status
  },
  mixins: [itemMixin, quotationMixin],
  props: {
    quotation: {
      required: true,
      type: Object
    },
    withClient: {
      type: Boolean,
      default: true
    },
    withDate: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    hasDefaultSlot () {
      return !!this.$slots.default
    },
    validClientSlot () {
      return this.quotation.client && this.withClient
    }
  }
}
</script>
